/*  MUI  */
import { Alert, AlertTitle } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import Logs from 'application/Shared/Pages/Logs/Logs';
import { Client } from 'application/Shared/Requests';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

class AdminLogs extends Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false, logAccess: false };

        const { clientId } = props.match.params;
        /*  requests  */
        this.Client = new Client(clientId);
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.Client.cancel();
    }

    load = async () => {
        try {
            const logAccess = await this.Client.hasLogAccess();

            if (!this.unmounted) {
                this.setState({ loaded: true, logAccess });
            }
        } catch (e) {
            /* */
        }
    };

    renderLogs = () => {
        const { t, location } = this.props;
        const { logAccess } = this.state;

        if (!logAccess) {
            return (
                <Alert severity="error" icon={false}>
                    <AlertTitle>
                        {t('Logs.application_logs_disabled')}
                    </AlertTitle>
                </Alert>
            );
        }

        return <Logs dashboardView location={location} />;
    };

    render() {
        const { t } = this.props;
        const { loaded } = this.state;

        return (
            <>
                <PageTitle title={t('Logs.application_security_logs')} />
                {loaded && this.renderLogs()}
            </>
        );
    }
}
export default withRouter(withTranslation()(AdminLogs));
